import { Link } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as Utilities from '../../../Components/Utils/Utils';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import * as KeyNames from '../../../api/KeyNames';
import Tooltip from '../../../Components/Message/Tooltip';
import Cards from '../../../Components/Cards/Cards';

export default function Afluencia() {

    let [afluencia, setAfluencia] = useState({
        date: null,
        parking: {
            today: {
                value: null,
                variation: null,
            },
            ytd: {
                value: null,
                variation: null,
            }
        },
        peatonal: {
            today: {
                value: null,
                variation: null,
            },
            ytd: {
                value: null,
                variation: null,
            }
        }
    });

    const token = useGetToken();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError } = useQuery([KeyNames.SessionData, afluencia],
        async () => await Api.DashboardAfluencia({ "token": token })
    );

    useEffect(() => {
        if (data) {
            if (/* !data.success || */data.data === null) { // 2do release. El data.success sirve para ver si la consulta da o no resultado, así que no se valida aquí.
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else if (data.data)
                setAfluencia(data.data);
        }
    }, [data]);

    if (isLoading || isLoading) return (<Loading />)
    if (isError || isError) return (<ErrorConnection error={isError/*.response.status*/} />)

    return (

        <div className="row g-5 g-xl-8">
            <div className="col-xl-3">
                <Link to="/Reportes/AfluenciaDiariaPeatonal">
                    <Cards
                        label="Detalle diario"
                        date={afluencia.date}
                        value={Utilities.comillasFix(afluencia.peatonal.today.value, true, 0)}
                        tooltipText="Vs Día Anterior"
                    />
                </Link>
            </div>
            <div className="col-xl-3">
                <Link to="/Reportes/AfluenciaMensualPeatonal">
                    <Cards
                        label="Detalle mensual"
                        date={afluencia.date}
                        value={Utilities.comillasFix(afluencia.peatonal.ytd.value, true, 0)}
                        tooltipText="Vs Año Anterior"
                    />
                </Link>
            </div>
            {/* <div className="col-xl-3">
                <Link to="/Reportes/AfluenciaDiariaParking">
                    <div className="card ">
                        <div className="card-body">
                            <div className="d-flex flex-stack mb-2">
                                <h3 className="card-label fw-bolder fs-5 mb-1">Hoy</h3>
                                <div className='d-flex flex-column text-end'>
                                    <span className="text-muted fw-bold fs-7">{afluencia.date}</span>
                                </div>
                            </div>
                            <div className="d-flex text-center flex-column text-dark pt-2">
                                <span className="fw-bold fs-7">Parking</span>
                                <div className="d-flex flex-wrap align-items-center justify-content-center pt-2">
                                    <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(afluencia.parking.today.value, true, 0)}</span>
                                    <div className="d-flex flex-wrap">
                                        {Utilities.setClassVariationDashboard(afluencia.parking.today.variation)}
                                        <div className="ms-2"><Tooltip message={"Vs Día Anterior"}></Tooltip></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div> */}
            {/* <div className="col-xl-3">
                <Link to="/Reportes/AfluenciaMensualParking">
                    <div className="card ">
                        <div className="card-body">
                            <div className="d-flex flex-stack mb-2">
                                <h3 className="card-label fw-bolder fs-5 mb-1">YTD</h3>
                                <div className='d-flex flex-column text-end'>
                                    <span className="text-muted fw-bold fs-7">{afluencia.date}</span>
                                </div>
                            </div>
                            <div className="d-flex text-center flex-column text-dark pt-2">
                                <span className="fw-bold fs-7">Parking</span>
                                <div className="d-flex flex-wrap align-items-center justify-content-center pt-2">
                                    <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(afluencia.parking.ytd.value, true, 0)}</span>
                                    <div className="d-flex flex-wrap">{Utilities.setClassVariationDashboard(afluencia.parking.ytd.variation)}
                                        <div className="ms-2"> <Tooltip message={"Vs Año Anterior"}></Tooltip>  </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div > */}
        </div >
    )
}